/* IOI: exact-match search (added July 2026)
 * Forces Shopify exact phrase matching (skips semantic-search padding) by
 * wrapping search queries in double quotes at submit/click time.
 * Covers: search form submits, "View all results" + other /search links.
 * Queries already using search syntax (quotes, field:, AND/OR/NOT, -) are untouched.
 */
(function () {
  function usesSyntax(q) {
    return q.indexOf('"') !== -1 || /\b(AND|OR|NOT)\b/.test(q) || /(^|\s)[\w.]+:/.test(q) || /(^|\s)-\w/.test(q);
  }
  // 1. Form submits (header drawer + search page)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var v = (input.value || '').trim();
    if (!v || usesSyntax(v)) return;
    input.value = '"' + v + '"';
  }, true);
  // 2. Links to /search?q=... ("View all results", popular searches, etc.)
  function quoteLink(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href*="/search"]') : null;
    if (!a) return;
    try {
      var url = new URL(a.href, location.origin);
      if (url.pathname.indexOf('/search') === -1) return;
      var q = (url.searchParams.get('q') || '').trim();
      if (!q || usesSyntax(q)) return;
      url.searchParams.set('q', '"' + q + '"');
      a.href = url.toString();
    } catch (err) { /* leave link as-is */ }
  }
  document.addEventListener('click', quoteLink, true);
  document.addEventListener('auxclick', quoteLink, true);
  // 3. Show the term without quotes in the search box on the results page
  function stripQuotes() {
    var inputs = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      var v = inputs[i].value || '';
      if (v.length > 1 && v.charAt(0) === '"' && v.charAt(v.length - 1) === '"') {
        inputs[i].value = v.slice(1, -1);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripQuotes);
  } else {
    stripQuotes();
  }
})();
